<template>
  <!-- 信息发布 -->
  <div class="page-solicitation">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form @keyup.enter.native="getTableList" class="com-search-box" ref="form" :model="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="关键字 :" prop="title">
              <el-input v-model="form.title" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="预约时间 :" prop="title">
              <el-date-picker v-model="time" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="daterange"
                start-placeholder="开始时间" @change="timeChange" end-placeholder="结束时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList">重置</el-button>

        <el-switch @change="ChangeWwjd" style="margin-left: 40px;" :value="value1" active-text="预约入口">
        </el-switch>

        <span class="edit-btn ml-20" :class="{ 'default-color': value1 }" @click="addJdzc">编辑</span>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="flex-box">
        <cmpMyExport @clearSelectsCall="clearSelectsCall" :chooseIds="chooseRowIds"
          chooseApi="/bsWwjdWeb/batchExport?arr=" :params="form" searchApi="/bsWwjdWeb/batchExportAll"></cmpMyExport>
        <div>
          <el-button :disabled="total <= 0" type="primary" plain @click="archive">归档</el-button>
          <el-button type="primary" plain @click="goList(2)">归档记录</el-button>
          <el-button type="primary" plain class="del-btn" @click="goList(3)">移除记录</el-button>
        </div>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :row-key="
            row => {
              return row.schemeId
            }
          " :data="tableData" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column label="序号">
            <template slot-scope="scope"><span>{{ scope.$index + 1 }}</span></template>
          </el-table-column>
          <!-- <el-table-column prop="createTimeStr" label="创建时间" min-width="15%">
            <template slot-scope="scope">
              <span>{{$common.formatDateString(scope.row.createTimeStr, 'yyyy-MM-dd')}}</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="name" label="联系人"></el-table-column>
          <el-table-column prop="phone" label="联系方式"></el-table-column>

          <el-table-column prop="createTime" label="预约时间">
            <template slot-scope="scope">
              <span>{{
                $common.formatDateString(scope.row.createTime, 'yyyy-MM-dd')
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="jdzcName" label="场次名称"></el-table-column>

          <!-- 操作 -->
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleView(scope.row)">查看</a>
              <a class="m-btn  m-danger" @click="handleDelete(scope.row)">不符移除</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background
            layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>
    <el-dialog title="编辑预约场次" :visible.sync="dialogOrderVisible" @close="cancelOrder" :close-on-click-modal="false"
      width="450px">
      <el-form class="g-form-grid" ref="orderForm" :model="orderForm" :rules="rules" label-width="120px">
        <el-form-item label="场次名称 :" prop="title">
          <el-input v-model="orderForm.title" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="开放预约数量 :" prop="quota">
          <el-input v-model="orderForm.quota" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="footer mt-30">
        <el-button @click="cancelOrder">取消</el-button>
        <el-button @click="editOrder" type="primary" :loading="loadingSave">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="查看详情" :close-on-press-escape="false" :visible.sync="dialogVisible" width="650px">
      <el-form class="g-form-grid" ref="form" :model="addForm" label-width="120px">
        <el-form-item label="场次名称 :" prop="title">
          <span>{{ addForm.jdzcName }}</span>
        </el-form-item>

        <el-form-item label="联系人姓名 :" prop="title">
          <span>{{ addForm.name }}</span>
        </el-form-item>

        <el-form-item label="联系方式 :" prop="title">
          <span>{{ addForm.phone }}</span>
        </el-form-item>

        <el-form-item label="身份证号 :" prop="title">
          <span>{{ addForm.card }}</span>
        </el-form-item>

        <el-form-item label="说明 :" prop="title">
          <span>{{ addForm.content }}</span>
        </el-form-item>

        <el-form-item label="文物图片 :" prop="title">
          <viewer :images="addForm.fileList" @inited="inited" rebuild :options="{ title: false }">
            <img v-show="false" v-for="(item, index) in addForm.fileList" :src="item.attPath" :key="index" />
          </viewer>

          <div class="flex-img">
            <div v-for="(item, index) in addForm.fileList" :key="index">
              <img class="img" @click="handlePreview(item.attPath)" :src="item.attPath" alt="" />
            </div>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import cmpMyExport from '@cmp/my-export'

export default {
  components: {
    cmpMyExport
  },
  data() {
    let validateQuota = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('预约数量不能为空'))
      } else if (value < this.total) {
        callback(new Error('预约数量必须大于当前预约人数'))
      } else {
        callback()
      }
    }
    return {
      form: {
        type: 1,
        title: '',
        dateStart: '',
        dateEnd: ''
      },
      orderForm: {
        title: '',
        quota: ''
      },
      orderRule: {},
      rules: {
        title: [
          { required: true, message: '场次名称不能为空', trigger: 'blur' }
        ],
        quota: [{ required: true, validator: validateQuota, trigger: 'blur' }]
      },
      time: [],
      addForm: {},
      dialogVisible: false,
      dialogOrderVisible: false,
      chooseRowIds: '',
      wwjdObj: {},
      value1: false,
      detailObj: {
        pics: [
          '/singleMuseum/attach/getImg?fileId=165664051862820476389168727411513&s=2217',
          '/singleMuseum/attach/getImg?fileId=165664051862820476389168727411513&s=2217'
        ]
      },
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      tableData: [],
      loadingSave: false,
      listLoading: true
    }
  },
  methods: {
    // 初始化表格
    initList(type) {
      this.listLoading = true
      // 信息发布列表
      this.$http
        .get('/bsWwjdWeb/list', {
          ...this.listQuery,
          ...this.form
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            this.tableData = res.result
            this.total = res.page.allRow
          }
        })
    },

    addJdzc(type) {
      if (type == 2) {
        this.dialogOrderVisible = true
      } else {
        if (!this.value1) {
          this.dialogOrderVisible = true
        }
      }
    },

    timeChange(arr) {
      if (!arr) {
        this.form.dateStart = ''
        this.form.dateEnd = ''
      } else {
        this.form.dateStart = arr[0]
        this.form.dateEnd = arr[1]
      }
    },

    ChangeWwjd(val) {
      // 没有专场新增
      if (!this.wwjdObj.title || !this.wwjdObj.quota) {
        this.addJdzc(2)
        return
      }
      if (this.total == this.wwjdObj.quota) {
        this.$message.warning('预约专场人数已满')
        return
      }

      if (val) {
        this.openWwjd()
      } else {
        this.closeWwjd()
      }
    },

    openWwjd() {
      this.$http.get('/webadmin/openWwjd').then(res => {
        if (res.success) {
          // this.$message.success('打开文物鉴定')
          this.getWwjd()
        } else {
          this.$message.error(res.message)
        }
      })
    },

    // 清空选中状态
    clearSelectsCall() {
      this.$refs.multipleTable.clearSelection()
    },

    closeWwjd() {
      this.$http.get('/webadmin/closeWwjd').then(res => {
        if (res.success) {
          // this.$message.success('关闭文物鉴定')
          this.getWwjd()
        } else {
          this.$message.error(res.message)
        }
      })
    },

    getWwjd() {
      this.$http.get('/webadmin/queryWwjd').then(res => {
        if (res.success) {
          this.wwjdObj = res.result
          this.value1 = res.result.wwjd === '1' ? true : false
          this.orderForm = {
            title: this.wwjdObj.title,
            quota: this.wwjdObj.quota
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },

    handleSelectionChange(list) {
      let arr = []
      list.forEach(item => {
        arr.push(item.id)
      })
      this.chooseRowIds = arr.join(',')
    },

    // 重置查询
    restList() {
      this.time = []
      this.form.dateStart = ''
      this.form.dateEnd = ''

      this.$refs['form'].resetFields()
      this.listQuery.currentPage = 1
      this.initList()
    },

    archive() {
      this.$common.confirm(
        {
          title: '归档',
          content: '是否确认归档？'
        },
        () => {
          this.$http.get('/bsWwjdWeb/archive').then(res => {
            if (res.success) {
              this.$message.success('归档成功')
              this.closeWwjd()
              this.initList()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },
    inited(viewer) {
      this.$viewer = viewer
    },

    handlePreview(imgUrl) {
      for (let i in this.addForm.fileList) {
        if (this.addForm.fileList[i].attPath == imgUrl) {
          this.$viewer.index = i
        }
      }
      this.$viewer.show()
    },

    goList(type) {
      this.$router.push({
        path: '/website/identify-record',
        query: { type }
      })
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 删除
    handleDelete(obj) {
      this.$common.confirm(
        {
          title: '移除',
          content: '是否确认移除？'
        },
        () => {
          this.$http
            .get('/bsWwjdWeb/delete', {
              id: obj.id
            })
            .then(res => {
              if (res.success) {
                this.$message.success('移除成功')
                this.getWwjd()
                this.initList()
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },

    handleView(obj) {
      this.operation = 'view'
      this.$http.get('/bsWwjdWeb/find', { id: obj.id }).then(res => {
        if (res.success) {
          if (res && res.result) {
            this.dialogVisible = true
            this.addForm = res.result
          }
        }
      })
    },

    editOrder() {
      this.$refs['orderForm'].validate(vaild => {
        if (vaild) {
          this.loadingSave = true
          this.$http
            .get('/webadmin/editWwjd', {
              ...this.orderForm
            })
            .then(res => {
              this.loadingSave = false
              if (res.success) {
                this.$message.success('预约场次设置成功')
                if (this.orderForm.quota == this.total) {
                  this.closeWwjd()
                } else {
                  this.openWwjd()
                }
                this.cancelOrder()
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(() => {
              this.loadingSave = false
            })
        }
      })
    },

    cancelOrder() {
      this.value1 = this.wwjdObj.wwjd === '1' ? true : false
      this.$refs['orderForm'].clearValidate()
      this.$refs['orderForm'].resetFields()
      this.dialogOrderVisible = false
    },

    handleCreate(type, id) {
      this.$refs.dialogCreateInfo.init(type, id)
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    }
  },
  created() {
    this.getWwjd()
    this.initList()
  }
}
</script>

<style lang="scss" scoped>
.flex-img {
  display: flex;
  flex-wrap: wrap;
  .img {
    width: 120px;
    height: 120px;
    margin-right: 20px;
    margin-bottom: 10px;
    object-fit: cover;
  }
}
.com-head-search-btns {
  display: flex;
  align-items: center;
}
.edit-btn {
  color: $primary;
  font-size: 14px;
  cursor: pointer;
  &.default-color {
    cursor: default;
    color: #9699a2;
  }
}

.flex-box {
  justify-content: space-between;
  .del-btn {
    margin-left: 120px;
  }
}

/deep/ .el-form-item__content {
  display: flex;
}
</style>
